var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useLocation, useNavigate } from 'react-router-dom';
import { checkLocalStorage, checkUserToken } from '@libs/@core/security/checkPathName';
import useGetProfileData from '@libs/hooks/useGetProfileData';
import { clearAccessTokenCookie, getAccessTokenCookie } from '@libs/utils/serverHelpers';
import useGetLanguageValues from '@libs/hooks/useGetLanguageValues';
import { useLanguageStore } from '@libs/stores';
var withAuth = function (WrappedComponent) {
    var ComponentWithAuth = function (props) {
        var accessToken = getAccessTokenCookie();
        var location = useLocation();
        var navigate = useNavigate();
        var _a = useLanguageStore(), key = _a.key, setKey = _a.setKey;
        if (location.pathname === '/auth/login' && !accessToken) {
            return _jsx(WrappedComponent, __assign({}, props));
        }
        if (!accessToken) {
            return checkLocalStorage({
                params: location.pathname,
                component: WrappedComponent,
                callBackNavigate: function () { return navigate('/auth/login'); },
                props: props
            });
        }
        var userInfo = useGetProfileData();
        var _b = useGetLanguageValues(), isLoading = _b.isLoading, isError = _b.isError, data = _b.data;
        if (isError) {
            clearAccessTokenCookie();
            navigate('/auth/login');
        }
        if (data && !key) {
            setKey(data);
        }
        return checkUserToken({
            data: __assign(__assign({}, userInfo), { isLoading: userInfo.isLoading || isLoading }),
            callBackNavigate: function () {
                navigate('/auth/login');
            },
            params: location.pathname,
            component: WrappedComponent,
            props: props
        });
    };
    return ComponentWithAuth;
};
export default withAuth;
